module.exports = __webpack_public_path__ + "img/red-alert-circle.32339230.svg";